jQuery(document).ready(function ($) {
	$('.block-video .video-play').on('click', function () {
		var $button = $(this);
		var $player = $button.closest('.video-player');

		if ($player.hasClass('is-playing')) return;

		$player.addClass('is-playing');

		var $iframe = $player.find('.video-embed iframe');
		if (!$iframe.length) return;

		// Append autoplay=1 only on user interaction so the embed never
		// auto-plays when Borlabs unwraps it on a returning visitor.
		var src = $iframe.attr('src') || '';
		if (src.indexOf('autoplay=') === -1) {
			src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
		}
		$iframe.attr('src', src);
	});
});
